module.exports = __webpack_public_path__ + "static/Satyr-09dd921342b802812f1bfe2479886646.jpg";